<section class="flex w-full flex-col">
  <div class="mb-2 flex items-center justify-between">
    <h2 class="!m-0 !max-w-none !font-base !text-[16px] !font-semibold">
      {{ "LATEST_RESEARCHES" | translate }}
    </h2>
    <button
      type="button"
      class="inline-block h-[20px] w-[20px] cursor-pointer bg-black dark:bg-white"
      style="
        mask: url(&quot;/assets/images/icons/remove.svg&quot;) center / 20px
          20px no-repeat;
      "
      (click)="clearHistory.emit()"
      [attr.aria-label]="'DELETE_SEARCH_HISTORY' | translate"
    ></button>
  </div>
  <ul>
    @for (term of research.slice(0, visibleResearchCount); track term) {
    <li class="mb-1">
      <button
        type="button"
        class="flex w-full cursor-pointer items-center text-left"
        (click)="researchSelected.emit(term)"
      >
        <span
          class="mr-2 inline-block h-[18px] w-[18px] shrink-0 bg-black dark:bg-white"
          style="
            mask: url(&quot;/assets/images/icons/clock.svg&quot;) center / 18px
              18px no-repeat;
          "
          aria-hidden="true"
        ></span>
        <span>{{ term }}</span>
      </button>
    </li>
    }
  </ul>
  @if (visibleResearchCount < research.length) {
  <button
    type="button"
    class="mt-2 cursor-pointer self-start underline"
    (click)="visibleResearchCount = visibleResearchCount + 5"
  >
    {{ "SHOW_MORE" | translate }}
  </button>
  }
</section>
